<script lang="ts">
	import { atLeastModerator } from '$lib/utils/roles';
	import { _ } from 'svelte-i18n';
	export let name: string;
	export let user_role: string;

	export let showPill = true;
</script>

<div class="wrapper">
	<div class="px-posted-by-author-name">{name}</div>
	{#if atLeastModerator({ role: user_role }) && showPill}
		<div class="adminPill">{$_('common.admin')}</div>
	{/if}
</div>

<style>
	.wrapper {
		display: flex;
		align-items: center;
		gap: var(--gutterSmall);
	}

	.px-posted-by-author-name {
		display: inline-block;
		max-inline-size: 235px;
		overflow: hidden;
		color: rgb(54 54 53);
		font-size: var(--fontSizeSmall);
		font-weight: 500;
		text-overflow: ellipsis;
		white-space: nowrap;
	}

	.adminPill {
		display: flex;
		align-items: center;
		padding-block: var(--gutterSmaller);
		padding-inline: var(--gutterSmall);
		border-radius: 20px;
		background-color: var(--grayLighter);
		color: var(--grayDark);
		font-size: var(--fontSizeSmallest);
		font-weight: bold;
	}
</style>
